import request from '../request';

export interface PersonalityTemplate {
  id: string;
  name: string;
  icon?: string;
  description?: string;
  promptTemplate: string;
  voiceStyle?: string;
  defaultExpressions?: string;
  isEnabled: boolean;
  sortOrder: number;
}

export const getPersonalityPage = (params: { current: number; size: number; keyword?: string }) => {
  return request.get('/admin/personality/page', { params });
};

export const getPersonalityList = () => {
  return request.get('/admin/personality/list');
};

export const getPersonalityById = (id: string) => {
  return request.get(`/admin/personality/${id}`);
};

export const addPersonality = (data: PersonalityTemplate) => {
  return request.post('/admin/personality', data);
};

export const updatePersonality = (data: PersonalityTemplate) => {
  return request.put('/admin/personality', data);
};

export const deletePersonality = (id: string) => {
  return request.delete(`/admin/personality/${id}`);
};

export const updatePersonalityStatus = (id: string, enabled: boolean) => {
  return request.put(`/admin/personality/${id}/status?enabled=${enabled}`);
};
